fx.ns("shared.components", class CoverThumb extends fx.DataHandler
{    
        constructor(parameters)
        {
            super(parameters.component);

            this._context = parameters.context;
            this._canvas = parameters.canvas;

            this._element = parameters.element;
            this._model = parameters.model;
            this._side = parameters.side;
            this._fontstyle = parameters.fontstyle;
            this._creationSize = parameters.creationSize;
            this._emptyPlaceHolder = parameters.emptyPlaceHolder;
            this._imageTimeOut = parameters.imageTimeOut;
            this._fullQuality = parameters.fullQuality;

            this.voffset = 0;
            this.offset = 0;

            if (this.model.creation.isBook && this.side)
            {
                if (this.element.isCover)
                {
                    if (this.side == "left")
                        this.offset = 0;
                    else
                        this.offset = (this.creationSize.width + this.creationSize.slice);
                }
                else
                {
                    if (this.side == "left")
                        this.offset = 0;
                    else
                        this.offset = this.creationSize.width;
                }
            }
            else
            if (this.model.creation.isCalendar)
            {
                this.voffset = this.creationSize.top;
                this.offset =  0;
            }
            else
                this.offset =  0;
            
            this.TO_RADIANS = Math.PI/180; 
        }

        get model()
        {
            return this._model;
        }


        get element()
        {
            return this._element;
        }

        get canvas()
        {
            return this._canvas;
        }

        get context()
        {
            return this._context;
        }

        get image()
        {
            return this._image;
        }

        get side()
        {
            return this._side;
        }

        get fontstyle()
        {
            return this._fontstyle;
        }

        get creationSize()
        {
            return this._creationSize;
        }

        get emptyPlaceHolder()
        {
            return this._emptyPlaceHolder;
        }

        get elementRotation()
        {
            return this.data.rotation || 0;
        }

        get elementRotationInner()
        {
            return this.data.rotation_inner || 0;
        }

        get elementX()
        {
            return this.data.x * this.creationSize.ratio;
        }

        get elementY()
        {
            return this.data.y * this.creationSize.ratio;
        }

        get elementWidth()
        {
            return this.data.width * this.creationSize.ratio;
        }

        get elementHeight()
        {
            return this.data.height * this.creationSize.ratio;
        }

        get elementXInner()
        {
            if (this.empty)
                return 0;
            else
                return this.data.x_inner * this.creationSize.ratio;
        }

        get elementYInner()
        {
            if (this.empty)
                return 0;
            else
                return this.data.y_inner * this.creationSize.ratio;
        }

        get elementWidthInner()
        {
            if (this.empty)
                return this.data.width * this.creationSize.ratio;
            else
                return this.data.width_inner * this.creationSize.ratio;
        }

        get elementHeightInner()
        {
            if (this.empty)
                return this.data.height * this.creationSize.ratio;
            else
                return this.data.height_inner * this.creationSize.ratio;
        }

        get photo()
        {
            return this.model.photos.find({id: this.data.content});
        }

        get empty()
        {
            return !this.photo || this.photo.deleted;
        }

        load()
        {
            this.delay(this.onLoadError, this._imageTimeOut || fx.get("settings").coverImageTimeOut);
        }

        loadImage(url)
        {
            this._image = new Image();
            this._image.setAttribute('crossorigin', 'anonymous');
            this._image.src = url;
            
            this.on("load", this._onImageLoad, this._image);
            this.on("error", this.onLoadError, this._image);
        }

        // where the component lies, in shares of the canvas, rotated by rotation degrees around its
        // top left corner as it is drawn : the place left empty when its image did not come
        get zone()
        {
            return {
                x : (this.elementX - this.offset) / this.canvas.width,
                y : (this.elementY - this.voffset) / this.canvas.height,
                width : this.elementWidth / this.canvas.width,
                height : this.elementHeight / this.canvas.height,
                rotation : this.elementRotation,
            };
        }

        // given up on : nothing more is drawn, nothing answers, and the image stops loading
        cancel()
        {
            this.delay(this.onLoadError, null);
            this._ready = true;

            if (this._image)
            {
                this.off("load", this._onImageLoad, this._image);
                this.off("error", this.onLoadError, this._image);
                this._image.src = "";
            }
        }

        // an image loaded past its timeout is not drawn : the canvas is drawing another page by now
        get late()
        {
            return !!this._ready;
        }

        _onImageLoad(e)
        {
            if (!this.late)
                this.onImageLoaded(e);
        }

        onImageLoaded(e)
        {
            this.ready();
        }

        // the image failed or took longer than coverImageTimeOut : the component is left out of the drawing
        onLoadError(e)
        {
            if (!this._ready)
                this.failed = true;

            this.ready();
        }

        // once : an image answering after its timeout would otherwise move the generator on a second
        // time, onto whatever page it is drawing by then
        ready()
        {
            this.delay(this.onLoadError, null);

            if (this._ready)
                return;

            this._ready = true;
            this.trigger("ready");
        }
    });
    